import { useTranslation } from "react-i18next";

const WhoWeAre = () => {
  const { t } = useTranslation();
  return (
    <article className="py-10 bg-white">
      <div className="flex items-center justify-between w-11/12 mx-auto">
        <section className="max-w-[500px]">
          <h1 className="text-mainBlue text-[32px] font-bold">{t("whoWeAre")}</h1>
          <p>{t("atMegtLogistics")}</p>
        </section>
        <section>
          <img src="/assets/whoWeAre.png" alt="who We Are" className="w-[532px]" />
        </section>
      </div>
    </article>
  );
};

export default WhoWeAre;
